const translations = {
  title: 'Creating Form',
  title_edit: 'Editing Form',
  generalSectionTitle: 'Basic information',
  accessSectionTitle: 'Access',
  themeSectionTitle: 'Theme',
  themeLogo: 'Logo',
  themeColor: 'Color',
  redirectionSection: 'Redirection',
  redirectionLabel: 'After responding, redirect to execution',
  validationRequired: 'Request validation when fill in',
  setupSection: 'Settings of conclusion',
  name: 'Name*',
  checklist: 'Checklist*',
  description: 'Description*',
  access: 'Access*',
  private: 'Private',
  public: 'Public',
  conclusionTitle: 'Conclusion message title',
  conclusionBody: 'Conclusion message body'
}

export default translations
